import React, { Component } from "react";
import { Col } from "reactstrap";
import styled from "styled-components";

export default class Card extends Component {
  constructor(props) {
    super(props);
    this.state = {
      turned: props.turned
    };
    this.createCard = this.createCard.bind(this);
    this.turnCard = this.turnCard.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.turned !== this.props.turned) {
      this.setState({ turned: this.props.turned });
    }
  }

  render() {
    return <JCol>{this.createCard()}</JCol>;
  }

  createCard() {
    const { frontLogo, backLogo, text, color, link } = this.props;
    const { turned } = this.state;
    if (turned)
      return (
        <CardBodyBack color={color} onMouseLeave={() => this.turnCard()}>
          <RowBack>
            <BackLogo src={backLogo} alt="logo" />
          </RowBack>
          <hr width="40%" color="white" />
          <RowBack>
            <Text>
              {text}{" "}
              {link.length > 0 && (
                <span>
                  Erfahren Sie mehr auf unserer <a href={link}>Webseite</a>.
                </span>
              )}
            </Text>
          </RowBack>
        </CardBodyBack>
      );
    return (
      <CardBodyFront
        onTouchEnd={() => this.turnCard()}
        onMouseEnter={() => this.turnCard()}
      >
        <FrontLogo src={frontLogo} alt="logo" />
      </CardBodyFront>
    );
  }

  turnCard() {
    this.setState(prevState => {
      return { turned: !prevState.turned };
    });
  }
}

const JCol = styled(Col)`
  min-width: 355px;
`;

const Text = styled.div`
  padding: 5px 10% 10% 10%;
`;

const CardBodyFront = styled.div`
  text-align: center;
  margin: auto;
  margin-top: 20px;
  background-color: #ccc;
  height: 530px;
  max-width: 400px;
`;

const CardBodyBack = styled.div`
  ${props =>
    props.color
      ? `background-color: rgb(${props.color});`
      : "background-color: #999;"}
  margin: auto;
  margin-top: 20px;
  height: 530px;
  max-width: 430px;
  color: white;
`;

const FrontLogo = styled.img`
  max-width: 100%;
  max-height: 100%;
  padding: 50% 10% 50% 10%;
`;

const RowBack = styled.div`
  height: 35%;
  text-align: center;
`;

const BackLogo = styled.img`
  max-height: 95%;
  max-width: 100%;
  padding: 15% 10% 0% 10%;
`;
